var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{staticClass:"wrapper-input",class:{ 'error-wrapper': _vm.error.length, disabled: _vm.disabled, filled: !!_vm.value }},[_c('input',_vm._g(_vm._b({staticClass:"ui-input",attrs:{"readonly":_vm.readonly}},'input',_vm.$props,false),{
      ..._vm.$listeners,
      input: event => _vm.$emit('input', event.target.value),
      focus: event => _vm.$emit('input', event.target.value),
    })),_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._t("default"),_c('transition',{attrs:{"name":"fade"}},[(_vm.error.length)?_c('p',{staticClass:"text-error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }